export const PERSON_ERROR_CODES = [
  'mapping_missing',
  'person_invalid_name',
  'person_email_required',
  'person_email_unverified',
];

// i18n key of the fixed copy for an error about the assessed person or the
// wallet, or null when the code has none. Provider messages are never shown.
export const getErrorCopyKey = (code) => {
  if (code === 'nawi_wallet_empty') return 'persons.nawiChat.walletEmpty';
  if (code === 'invalid_dob') return 'persons.nawiChat.dobRequired.invalid';
  if (PERSON_ERROR_CODES.includes(code)) {
    return `persons.nawiChat.personError.${code}`;
  }
  return null;
};
